// extracted by mini-css-extract-plugin
module.exports = {"tag":"course-tag_tag__2-4W8","icon":"course-tag_icon__1a2MQ"};